import { DocumentLists } from "@nju/feature-portal-documents";
import { Footer } from "@nju/feature-portal-footer";
import { Header, HeaderBackgroundWrapper } from "@nju/feature-sales-header";
import { BlockContent, LayoutWrapper } from "@nju/ui";

export default function RegulationsAndPrices() {
  return (
    <LayoutWrapper>
      <HeaderBackgroundWrapper>
        <Header />
      </HeaderBackgroundWrapper>
      <BlockContent spacing="l">
        <DocumentLists
          title="aktualne regulaminy i cenniki"
          validity="EFFECTIVE"
          variant="sales"
        />
      </BlockContent>
      <Footer />
    </LayoutWrapper>
  );
}
